import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

import './StaffingPlanUI.css'

var data = {
	score: 0,
	avatars: [
		{
			name: 'Heather',
			currentCount: 0,
			getCorrectPatientCount: (data: StaffingPlanUIConfig) => {
				return data.heatherPatients;
			}
		},
		{
			name: 'Marco',
			currentCount: 0,
			getCorrectPatientCount: (data: StaffingPlanUIConfig) => {
				return data.marcoPatients;
			}
		},
		{
			name: 'Miranda',
			currentCount: 0,
			getCorrectPatientCount: (data: StaffingPlanUIConfig) => {
				return data.mirandaPatients;
			}
		},
		{
			name: 'Ben',
			currentCount: 0,
			getCorrectPatientCount: (data: StaffingPlanUIConfig) => {
				return data.benPatients;
			}
		},
		{
			name: 'Me',
			currentCount: 0,
			getCorrectPatientCount: (data: StaffingPlanUIConfig) => {
				return data.mePatients;
			}
		}
	]
};

var attemptCount = 0;

const StaffingPlanWrong = () => {
	const [show, setShow] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			console.log(show);
			setShow(!show);
		}, 250);
	}, [show])
	
	return (
		<div style={{
			position: 'absolute',
			pointerEvents: 'all',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			{show ? <img tabIndex={0} aria-label='incorrect' style={{
				transform: 'translate(-50%, -50%) rotate(45deg)',
				position: 'absolute',
				top: '50%',
				left: '50%'
			}} src="./assets/images/general/components/staffing-plan/wrong.png" /> : (null)}
		</div>
	);
};

const StaffingPlanUI = (props: UIProperties<StaffingPlanUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [showWrong, setShowWrong] = useState(false);

	const getChartText = () => {
		return `
			Heather is looking after Mr. Williams on Room 426.

			Heather is looking after Mr. Armstrong on Room 427.

			Heather is looking after Mis. Li on Room 428.

			Heather is looking after Mrs. Srisati on Room 429.

			Heather has 4 patients.



			Marco is looking after Mr. Mehta on Room 430.

			Marco is looking after Mr. Advani on Room 431.

			Marco is looking after Mr. Anderson on Room 433.

			Marco is looking after Mr. Rob on Room 435.

			Marco has 4 patients.

			Miranda is looking after Mr. Martinez on Room 436.

			Miranda is looking after Mrs. Garcia on Room 437.

			Miranda is looking after Mr. Zolic on Room 438.

			Miranda is looking after Mrs. Tindall on Room 440.

			Miranda has 4 patients.



			Ben is looking after Mr. Gupta on Room 441.

			Ben is looking after Mr. Gonzales on Room 442.

			Ben is looking after Mrs. Wilson on Room 443.

			Ben is looking after Mr. Smith on Room 444.

			Ben is looking after Mr. Chen on Room 445.

			Ben has 5 patients.

			You the charge Nurse have 0 patients assigned.
		`;
	}

	const updateCounter = (avatarIndx: number, count: number) => {
		if(count > 9) {
			count = 9;
		}

		if(count < 0) {
			count = 0;
		}

		data.avatars[avatarIndx].currentCount = count;
		setForceUpdate(!forceUpdate);
	};

	return (
		<div className="staffing-plan-ui-container in-game-ui-container ui-top-most-container">
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				width: '1273px',
				height: '755px',
				transform: 'translate(-50%, -50%)'
			}} tabIndex={0} id='staffing-plan-ui-first' aria-label='Staffing Plan'>
				<img src="./assets/images/general/components/nurse-station-computer/nurse-station-background.png"/>
				<p tabIndex={0} className="title-font" style={{
					position: 'absolute',
					top: '60px',
					left: '0px',
					margin: '0',
					width: '100%',
					textAlign: 'center',
					fontSize: '25pt'
				}}>How many patients does your staff have?</p>
				<p className="regular-description-font" style={{
					position: 'absolute',
					top: '110px',
					left: '0px',
					margin: '0',
					width: '100%',
					textAlign: 'center'
				}} tabIndex={0}>Please select from the staff counter buttons below to indicate the current patient load of each staff member.</p>
				<div style={{
					position: 'absolute',
					top: '150px',
					left: '50%',
					width: '900px',
					transform: 'translate(-50%, 0)'
				}}>
					{data.avatars.map((a, ai) => {
						return (
						<div style={{
							position: 'relative',
							display: 'inline-block',
							width: '180px'
						}}>
							<img src="./assets/images/general/components/staffing-plan/staffingplan_frame.png"/>
							<p tabIndex={0} className="regular-description-font" style={{
								position: 'absolute',
								top: '4px',
								left: '0',
								margin: '0',
								width: '100%',
								textAlign: 'center',
								fontSize: '18pt'
							}}>{a.name}</p>

							{globals.showDebugForComponents && globals.showDebugAnswerTypes ? (<p className="regular-description-font" style={{
								position: 'absolute',
								bottom: '16px',
								left: '30px',
								margin: '0',
								width: '100%',
								textAlign: 'center',
								fontSize: '18pt',
								color: 'green'
							}}>{a.getCorrectPatientCount(props.parameters)}</p>) : (null)}

							<GeneralButton parameters= {{
								ariaLbl: 'decrease amount',
								srcIdle: './assets/images/general/components/staffing-plan/staffingplan_minus_main.png',
								srcHighlight: './assets/images/general/components/staffing-plan/staffingplan_minus_down.png',
								top: '32px',
								left: '0px',
								width: '53.33px',
								onClicked: () => {
									updateCounter(ai, a.currentCount-1);
								}
							}}/>
							<div style={{
								position: 'absolute',
								top: '33px',
								left: '50%',
								transform: 'translate(-50%, 0px)',
								width: '35px',
							}}>
								<img src="./assets/images/general/components/staffing-plan/staffingplan_number_frame.png"/>
								<p className="regular-description-font" style={{
									position: 'absolute',
									top: '7px',
									left: '0',
									margin: '0',
									width: '100%',
									textAlign: 'center',
									fontSize: '18pt'
								}} tabIndex={0} aria-label={'Current count for ' + a.name + '. ' + a.currentCount}>{a.currentCount}</p>
							</div>
							
							<GeneralButton parameters= {{
								ariaLbl: 'increase amount',
								srcIdle: './assets/images/general/components/staffing-plan/staffingplan_plus_main.png',
								srcHighlight: './assets/images/general/components/staffing-plan/staffingplan_plus_down.png',
								top: '32px',
								left: '128px',
								width: '53.33px',
								onClicked: () => {
									updateCounter(ai, a.currentCount+1);
								}
							}}/>
							
						</div>)
					})}
				</div>
				<div style={{
					position: 'absolute',
					top: '230px',
					left: '10px',
					width: '1260px',
					height: '426px',
					overflow: 'auto',
					pointerEvents: 'all'
				}} className="special-container">
					<img tabIndex={0} aria-label={getChartText()} src="./assets/images/general/components/staffing-plan/excel.png" />
				</div>
				<GeneralButtonWithText parameters= {{
					id:'staffing-plan-ui-last',
					text: 'Submit',
					top: '652px',
					left: '534px',
					width: '413.33px',
					onClicked: () => {
						if(props.parameters.isSummative){
							props.parameters.onDone(data);
							return
						}
						var isCorrect = data.avatars.filter(a => a.getCorrectPatientCount(props.parameters) === a.currentCount).length === data.avatars.length;

						var audio = document.getElementById(isCorrect ? 'correct-audio' : 'wrong-audio');
						
						if(!globals.isMuted) {
							(audio as any).play()
						}
						
						if(isCorrect) {
							data.score = 0;
							switch(attemptCount) {
								case 0:
									data.score = 1000;
									break;
								case 1:
									data.score = 500;
									break;
								case 2:
									data.score = 250;
									break;
								default: 
									data.score = 0;
									break;
							}
							props.parameters.onDone(data);
						} else {
							setShowWrong(true);
							attemptCount++;
							setTimeout(() => {
								setShowWrong(false);
							}, 2000);
						}
					}
				}}/>
			</div>
			{showWrong ? <div style={{
				position: 'absolute',
				top: '0',
				left: '0',
				width: '100%',
				height: '100%'
			}}>
				<StaffingPlanWrong></StaffingPlanWrong>
			</div> : (null)}
			{globals.showDebugForComponents ? (
				<div style={{
					position: 'absolute',
					top: '80px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<button style={{
						color: 'white',
					}} onMouseEnter={() => {
						var rollOverAudio = document.getElementById('button-rollover');
						
						if(!globals.isMuted) {
							(rollOverAudio as any).play();
						}
					}} onClick={() => {	
						var clickAudio = document.getElementById('button-click');
						
						if(!globals.isMuted) {
							(clickAudio as any).play();
						}
						data.avatars[0].currentCount = 4;
						data.avatars[1].currentCount = 4;
						data.avatars[2].currentCount = 4;
						data.avatars[3].currentCount = 5;
						data.avatars[4].currentCount = 0;
						setForceUpdate(!forceUpdate);
					}}>
						Set Correct Answers (Staffing Plan)
					</button>
				</div>
			) : (null)}
		</div>
	);

};


export interface StaffingPlanUIConfig extends BaseConfig {
	isSummative: boolean;
	heatherPatients: number;
	marcoPatients: number;
	mirandaPatients: number;
	benPatients: number;
	mePatients: number;
	onDone: (data:any) => void;
}

export default StaffingPlanUI;